import { CourseType } from '../../../types'

export const getCourseResourceCount = (course?: CourseType) => {
  if (!course || !course?.modules?.length) {
    return 0
  }

  const allResources: any[] = []

  for (const module of course.modules) {
    for (const lesson of module.lessons) {
      allResources.push([...(lesson?.additionalFiles || [])])
    }
  }

  return allResources.length
}
